import { SyntheticEvent } from "react";
import noImage from "../assets/svg/noImage.svg";

export const handleImageLoadError = ({
	currentTarget,
}: SyntheticEvent<HTMLImageElement, Event>) => {
	currentTarget.src = noImage;
	currentTarget.onerror = null;
};
